import { render, staticRenderFns } from "./AmpifireHeader.vue?vue&type=template&id=2ae9ab40&scoped=true&"
import script from "./AmpifireHeader.vue?vue&type=script&lang=ts&"
export * from "./AmpifireHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AmpifireHeader.vue?vue&type=style&index=0&id=2ae9ab40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae9ab40",
  null
  
)

export default component.exports